import {
  LuSearch,
  LuChevronDown,
  FiCalendar,
} from "@/Components/Icons/Icons.jsx";
import { stateOptions } from "./Shipmentstateoption.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "40%",
      rows: {
        row1: [
          {
            name: "shipmentDischargePort",
            label: "Discharge Port",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getPorts",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
            autofillTargets: {
              dischargeCountry: "portCountryName",
            },
          },
        ],
        row2: [
          {
            name: "dischargeCountry",
            label: "Discharge Country",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
        row3: [
          {
            name: "shipmentDestinationPort",
            label: "Destination port",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getPorts",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
            autofillTargets: {
              destinationCountry: "portCountryName",
            },
          },
        ],
        row4: [
          {
            name: "destinationCountry",
            label: "Destination Country",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
        row5: [
          {
            name: "shipmentAirlineCode",
            label: "AirLine",
            component: "text-field",
            width: "30%",
            isGet: false,
            disabled: true,
          },
          {
            name: "shipmentAirline",
            label: "AirLine",
            component: "text-field",
            width: "80%",
            icon: LuSearch,
            iconColor: "gray-400",
            endpoint: "getAirline",
            type: "autocomplete",
            autofillTargets: {
              shipmentAirlineCode: "description",
            },
          },
          {
            name: "shipmentShiplineCode",
            label: "Ship Line",
            component: "text-field",
            width: "30%",
            isGet: false,
            disabled: true,
          },
          {
            name: "shipmentShippingLine",
            label: "Ship Line",
            component: "text-field",
            width: "80%",
            icon: LuSearch,
            iconColor: "gray-400",
            endpoint: "getShipLineMaster",
            type: "autocomplete",
            autofillTargets: {
              shipmentShiplineCode: "description",
            },
          },
        ],

        row6: [
          {
            name: "shipmentFlightNumber",
            label: "Flight No/Date",
            component: "text-field",
            width: "50%",
          },
          {
            name: "shipmentFlightDate",
            component: "dateselector",
            endIconName: FiCalendar,
            width: "50%",
          },
          {
            name: "shipmentVesselName",
            label: "Vessel No/Date",
            component: "text-field",
            width: "50%",
          },
          {
            name: "shipmentSailingDate",
            component: "dateselector",
            endIconName: FiCalendar,
            width: "50%",
          },
        ],
        row7: [
          {
            name: "shipmentVoyogeNumber",
            label: "Voyoge Name",
            component: "text-field",
            width: "50%",
          },
        ],

        row8: [
          {
            name: "shipmentEgmNo",
            label: "EGM NO/Date",
            component: "text-field",
            width: "50%",
          },
          {
            name: "shipmentEgmDate",
            component: "dateselector",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            width: "50%",
          },
        ],

        row9: [
          {
            name: "shipmentMawbNo",
            label: "MAWB NO/Date",
            component: "text-field",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            width: "50%",
          },
          {
            name: "shipmentMawbDate",
            component: "dateselector",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            // disabled: true,

            width: "50%",
          },
          {
            name: "shipmentMblNo",
            label: "MBL NO/Date",
            component: "text-field",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            width: "50%",
          },
          {
            name: "shipmentMblDate",
            component: "dateselector",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            // disabled: true,

            width: "50%",
          },
        ],

        row10: [
          {
            name: "shipmentHawbNo",
            label: "HAWB NO/Date",
            component: "text-field",
            iconColor: "gray-400",
            width: "50%",
          },
          {
            name: "shipmentHawbDate",
            component: "dateselector",
            width: "50%",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            // disabled: true,
          },
          {
            name: "shipmentHblNo",
            label: "HBL NO/Date",
            component: "text-field",
            iconColor: "gray-400",
            width: "50%",
          },
          {
            name: "shipmentHblDate",
            component: "dateselector",
            width: "50%",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            // disabled: true,
          },
        ],
        row11: [
          {
            name: "shipmentPreCarriageBy",
            label: "Pre-Carriag by",
            component: "text-field",
          },
        ],
        row12: [
          {
            name: "shipmentPlaceOfReceipt",
            label: "Place of Receipt",
            component: "text-field",
          },
        ],

        row13: [
          {
            name: "shipmentTranshipperCode",
            label: "Transhipper Code",
            component: "text-field",
          },
        ],
        row14: [
          {
            name: "shipmentGatewayPort",
            label: "Gateway Port",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getGateway",
          },
        ],
        row15: [
          {
            name: "shipmentStateOfOrigin",
            label: "State Of Origin",
            component: "dropdown",
            options: stateOptions,
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
          },
        ],
        row16: [
          {
            name: "shipmentAnnexureCFilled",
            label: "Annexure-C Details being filed with Annexure-A.......",
            component: "checkboxbox",
          },
        ],
      },
    },
    {
      column: "colum2",
      columnWidth: "55%",
      rows: {
        row1: [
          {
            name: "shipmentNatureOfCargo",
            label: "Nature Of Cargo",
            component: "dropdown",
            placeholder: "P-Non Containerised Packaged",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            width: "71%",
            disabled: true,
            options: [
              { label: " C- Containerised", value: "C-Containerised" },
              {
                label: "P-Non Containerised Packaged",
                value: "P-Non Containerised Packaged",
              },
              { label: "LB - Liquid Bulk", value: "LB - Liquid Bulk" },
              { label: "DB - Dry Bulk", value: "DB - Dry Bulk" },
              {
                label: "CP -Containerised and Packaged",
                value: "CP -Containerised and Packaged",
              },
            ],
            value: "C-Containerised",
          },
        ],

        row2: [
          {
            name: "shipmentTotalNoOfPkgs",
            label: "Total No.of Pkgs",
            component: "text-field",
            width: "35%",
            dataType: "int",
            unDependsOn: "shipmentNatureOfCargo",
            unDependsValue: ["LB - Liquid Bulk", "DB - Dry Bulk"],
          },
          {
            name: "shipmentTotalNoOfPkgsUnit",
            component: "text-field",
            width: "33%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity",
            unDependsOn: "shipmentNatureOfCargo",
            unDependsValue: ["LB - Liquid Bulk", "DB - Dry Bulk"],
          },
          {
            name: "PackageDetails",
            label: "Package Details",
            component: "backlink",
            action: "openSubDialog",
            subComponent: "PackageDetails",
            sx: {
              mt: 5,
            },
            unDependsOn: "shipmentNatureOfCargo",
            unDependsValue: ["LB - Liquid Bulk", "DB - Dry Bulk"],
          },
        ],
        row3: [
          {
            name: "shipmentLoosePkgs",
            label: "Loose Pkgs",
            component: "text-field",
            width: "35%",
            dataType: "int",
            unDependsOn: "shipmentNatureOfCargo",
            unDependsValue: [
              "C-Containerised",
              "LB - Liquid Bulk",
              "DB - Dry Bulk",
            ],
          },

          {
            name: "shipmentPkgsInMawb",
            label: "Pkts in  MAMB",
            component: "text-field",
            width: "33%",
            dataType: "int",
          },
          {
            name: "shipmentNoOfContainer",
            label: "No of Container",
            component: "text-field",
            width: "33%",
            dataType: "int",
            unDependsOn: "shipmentNatureOfCargo",
            unDependsValue: [
              "P-Non Containerised Packaged",
              "LB - Liquid Bulk",
              "DB - Dry Bulk",
            ],
          },
        ],
        row4: [
          {
            name: "shipmentGrossWeight",
            label: "Gross Weight",
            component: "text-field",
            width: "35%",
            dataType: "int",
          },
          {
            name: "shipmentGrossWeightUnit",
            component: "text-field",
            width: "33%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],

        row5: [
          {
            name: "shipmentNetWeight",
            label: "Net Weight",
            component: "text-field",
            width: "35%",
            dataType: "int",
          },
          {
            name: "shipmentNetWeightUnit",
            component: "text-field",
            width: "33%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],

        row6: [
          {
            name: "shipmentVolume",
            label: "Volume",
            component: "text-field",
            width: "35%",
            dataType: "int",
          },
          {
            name: "shipmentVolumeUnit",
            component: "text-field",
            width: "33%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getVolume",
          },
        ],
        row7: [
          {
            name: "shipmentChargeableWeight",
            label: "Chargeable Weight",
            component: "text-field",
            width: "35%",
            dataType: "float",
          },
          {
            name: "shipmentChargeableWeightUnit",
            component: "text-field",
            width: "33%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row8: [
          {
            name: "shipmentMarksAndNumbers",
            actionText: "Marks & Nos",
            component: "textarea",
            height: 250,
            width: "89%",
          },
        ],
      },
    },
  ],
};
